import React, { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ChangeBgIcon from '../../../Icons/24x24/ChangeBg';
import ActionBarButton from '../../_partials/ActionBarButton';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import { BiEventType } from '../../../biLogger/constants';
var EditBackgroundButton = function (_a) {
    var deviation = _a.deviation, currentBackgroundId = _a.currentBackgroundId, onInitialize = _a.onInitialize, showBackgroundPicker = _a.showBackgroundPicker, isBackgroundsPopupOpen = _a.isBackgroundsPopupOpen;
    var t = useTranslation().t;
    useEffect(function () {
        onInitialize();
    }, [onInitialize]);
    var onClick = useCallback(function () {
        if (isBackgroundsPopupOpen) {
            return;
        }
        showBackgroundPicker(deviation);
    }, [deviation, isBackgroundsPopupOpen, showBackgroundPicker]);
    return (React.createElement(ActionBarButton, { tooltip: t('deviation.backgrounds.change'), onClick: onClick, isEditAction: true, isRelatedPopupOpen: isBackgroundsPopupOpen, biData: {
            evid: BiEventType.CHANGE_BACKGROUND_CLICK,
            itemid: deviation.deviationId,
            typeid: getDeviationResourceType(deviation),
            background_id: currentBackgroundId,
        } },
        React.createElement(ActionBarIcon, { icon: ChangeBgIcon })));
};
EditBackgroundButton.displayName = 'EditBackgroundButton';
export default EditBackgroundButton;
//# sourceMappingURL=EditBackgroundButton.js.map